import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';

import Field from './Field';
import eyeIcon from '../../images/icon-password-eye.svg';

const Container = styled.div`
  position: relative;
`;

const Icon = styled.i`
  width: 24px;
  height: 24px;
  background: url(${eyeIcon}) no-repeat 0 0;
  background-size: contain;
  cursor: pointer;
  position: absolute;
  top: 37px;
  right: 8px;
`;

type PasswordFieldProps = {
  onChange(e: React.ChangeEvent<any>): void;
  onBlur(e: React.FocusEvent<any>): void;
  value: string;
  valid: boolean;
  errorMessage?: string;
  optionalText?: string;
  optionalLink?: string;
  label?: string;
  name: string;
  placeholder?: string;
  type?: never;
};

const PasswordField = ({
  onChange, onBlur, value, valid, errorMessage, optionalText, optionalLink, label, name, placeholder,
}: PasswordFieldProps) => {
  const passwordRef = useRef<HTMLInputElement>(null);
  const handleIconClick = useCallback(() => {
    const field = passwordRef.current;
    if (field) {
      const type = field.getAttribute('type') === 'password' ? 'text' : 'password';
      field.setAttribute('type', type);
    }
  }, []);

  return (
    <Container>
      <Field
        type="password"
        label={label}
        optionalText={optionalText}
        optionalLink={optionalLink}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        valid={valid}
        errorMessage={errorMessage}
        ref={passwordRef}
        placeholder={placeholder}
      />
      <Icon onClick={handleIconClick} />
    </Container>
  );
};

PasswordField.defaultProps = {
  optionalText: '',
  optionalLink: '',
  label: 'Mot de passe',
  placeholder: '',
  type: 'password',
  errorMessage: '',
};

export { PasswordField };
